<template>
  <l-layer-group
    layer-type="overlay"
    name="Radiation Diagram"
    :visible="true"
  >
    <l-circle
      v-for="(radius, i) in [500000, 1000000, 1500000, 2000000, 2500000, 3000000]"
      :key="i"
      :lat-lng="center"
      :radius="radius"
      :weight="1"
      :opacity="0.3"
      :fillOpacity="0"
      color="black"
    />
    <l-polyline
      v-for="angle in angles"
      :key="'A' + angle"
      :lat-lngs="[center, getCircunferencePoint(center, angle)]"
      :opacity="0.3"
      :weight="1"
      color="black"
    />
  </l-layer-group>
</template>

<script setup>
import { computed } from 'vue';
import { LLayerGroup, LCircle, LPolyline } from "vue2-leaflet";
import L from 'leaflet';

defineProps({
  center: {
    type: Array,
    required: true
  }
});

const angles = computed(() => {
  const list = [];
  for (let i = 0; i < 360; i += 22.5) {
    list.push(i);
  }
  return list;
});

function getCircunferencePoint(center, angle) {
  // Credit to Leaflet.GeometryUtil: http://makinacorpus.github.io/Leaflet.GeometryUtil/index.html
  const destination = (latlng, heading, distance) => {
    let a = L.latLng(latlng[0], latlng[1]);
    let b = L.latLng(90, 0);
    if (a.distanceTo(b) < 3100000) {
      return latlng; // return the same point for stations too on the north
    }

    heading = (heading + 360) % 360;
    const rad = Math.PI / 180;
    const radInv = 180 / Math.PI;
    const R = 6378137; // approximation of Earth's radius
    const lon1 = latlng[1] * rad;
    const lat1 = latlng[0] * rad;
    const rheading = heading * rad;
    const sinLat1 = Math.sin(lat1);
    const cosLat1 = Math.cos(lat1);
    const cosDistR = Math.cos(distance / R);
    const sinDistR = Math.sin(distance / R);
    const lat2 = Math.asin(sinLat1 * cosDistR + cosLat1 *
      sinDistR * Math.cos(rheading));
    let lon2 = lon1 + Math.atan2(Math.sin(rheading) * sinDistR *
      cosLat1, cosDistR - sinLat1 * Math.sin(lat2));
    lon2 = lon2 * radInv;
    lon2 = lon2 > 180 ? lon2 - 360 : lon2 < -180 ? lon2 + 360 : lon2;

    // hack to avoid longitude jumps
    if (lon2 - latlng[1] < 100) {
      lon2 += 360;
    }
    if (lon2 - latlng[1] > 100) {
      lon2 -= 360;
    }

    return [lat2 * radInv, lon2];
  };

  return destination(center, angle, 3000000);
}
</script>